import { Inject, Injectable } from "@angular/core"

import { VALIDATION_CONTEXT } from "../validation/validation-context"
import { AppValidationContext } from "../validators/app-validation-context"

@Injectable({ providedIn: "root" })
export class ValidationService {
  constructor(
    @Inject(VALIDATION_CONTEXT)
    private appValidationContext: AppValidationContext
  ) {}
}
